/// <reference path="../../_ext/editors/ItemGridEditor.ts" />
namespace TabAurous.Administration {
    import fld = SequenceDetailsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class SequenceDetailsEditor extends _Ext.ItemGridEditor<SequenceDetailsRow> {
        protected getColumnsKey() { return 'Administration.SequenceDetails'; }
        protected getDialogType() { return SequenceDetailsDialog; }
        protected getLocalTextPrefix() { return SequenceDetailsRow.localTextPrefix; }

        private pendingChanges: Q.Dictionary<any> = {};
        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            //**** Master ****//
            buttons.push({
                title: "Select Sequence",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    var grid = OMS.DepartmentProcessDetailsGrid;
                    // **** Validate Party before Item Selection ****  
                    var filters: _Ext.SelectGridFilters = {

                    }

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Department / Process"
                    });

                    pickerDialog.onSuccess = (selectedItems: OMS.DepartmentProcessDetailsRow[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProcessId == t.ProcessId) });
                        //this.view.setItems([]);
                        var self = this;
                        for (var i = 0; i < selectedItems2.length; i++) {
                            var Seq = selectedItems2[i];
                            var newSeq: SequenceDetailsRow = {
                                DepartmentId: Seq.DepartmentId,
                                DeptName: Seq.DeptName,
                                ProcessId: Seq.ProcessId,
                                ProcessName: Seq.ProcessName,
                                Priority: 0
                            }
                            newSeq[self.getIdProperty()] = "`" + self.nextId++;
                            var t = newSeq;
                            self.view.addItem(newSeq);
                        }
                    }

                    pickerDialog.dialogOpen();
                },
            });
            return buttons;
        }


        protected getColumns() {

            var columns = super.getColumns();
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);

            Q.first(columns, x => x.field === fld.Priority).format = int;

            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            //this.view.refresh();
            return columns;
        }
    }
}